import { ReactComponent as Icon } from "../icons/season.svg";

const Season = ({color, wth, curs, clickFunc}) => {
  return (
    <div>
      <Icon style={({fill: color, width: wth, height: wth, cursor: curs, marginTop: "4px"})} onClick={clickFunc}/>
    </div>
  );
};

export default Season;